module.exports = __webpack_public_path__ + "img/invite_reule_close.a23b137b.png";